// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccountInfoActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import AccountUtils from 'modules/Account/Izenda.AccountUtils';
// $FlowFixMe
import { isNil, curry } from 'lodash/fp';

/**
 * Handle on change tenant name
 * @param  {Object} props
 * @param  {Object} value
 */
function onChangeTenantName(props: any, e: any): void {
  props.store.model.updateProperty('tenantName', e.target.value);
}

/**
 * Handle on change user name.
 * @param  {Object} props
 * @param  {Object} value
 */
function onChangeUserName(props: any, e: any): void {
  props.store.model.updateProperty('userName', e.target.value);
}

/**
 * Handle on change first name.
 * @param  {Object} props
 * @param  {Object} value
 */
function onChangeFirstName(props: any, e: any): void {
  props.store.model.updateProperty('firstName', e.target.value);
}

/**
 * Handle on change last name.
 * @param  {Object} props
 * @param  {Object} value
 */
function onChangeLastName(props: any, e: any): void {
  props.store.model.updateProperty('lastName', e.target.value);
}

/**
 * Handle on change email address.
 * @param  {Object} props
 * @param  {Object} value
 */
function onChangeEmailAddress(props: any, e: any): void {
  props.store.model.updateProperty('emailAddress', e.target.value);
}

/**
 * Handle on click next.
 * @param  {Object} props
 */
function onClickNext(props: any): any {
  return () => {
    const { store, validation } = props;

    validation.validate().then(result => {
      if (result) {
        return store.validatePasswordLink().then(result => {
          if (!isNil(result.messages)) {
            validation.updateErrors(result.messages);
          }
        });
      }
      return Promise.resolve(false);
    });
  };
}

const accountInfoActions = withHandlers({
  checkShowOrganization: AccountUtils.checkShowOrganization,
  onChangeTenantName: curry(onChangeTenantName),
  onChangeUserName: curry(onChangeUserName),
  onChangeFirstName: curry(onChangeFirstName),
  onChangeLastName: curry(onChangeLastName),
  onChangeEmailAddress: curry(onChangeEmailAddress),
  onClickNext: onClickNext
});

export default accountInfoActions;



// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.AccountInfoActions.js